import { Component, Input, OnInit } from '@angular/core';
import { GetPasswordComplexitySettingsResult } from '@modules/api/get-password-complexity-settings-result.generated';
import { PasswordComplexitySettingsService } from '@modules/common/services/password-complexity-settings.service';

@Component({
    selector: 'app-password-requirements',
    templateUrl: './password-requirements.component.html',
    styleUrls: ['./password-requirements.component.scss']
})
export class PasswordRequirementsComponent implements OnInit{
    @Input()
    public passwordString?: string;
    public model?: GetPasswordComplexitySettingsResult;

    constructor(private _passwordComplexitySettingsService: PasswordComplexitySettingsService
    ) { }

    ngOnInit() {
        this._passwordComplexitySettingsService.passwordComplexitySettingsChanged
            .subscribe(result => this.model = result);
    }

    public meetsPatternRequirements(): boolean {
        return (!this.model) ||
            (this.model.minPatternsFulfilled === 0) ||
            (!this.model.patterns) ||
            (this.model.patterns.filter(pattern => { return this.matchesPattern(pattern.pattern); }).length >= this.model.minPatternsFulfilled);
    }

    public matchesPattern(pattern?: string): boolean {
        return !!this.passwordString && new RegExp(pattern || '').test(this.passwordString);
    }

    public meetsLengthRequirement(): boolean {
        return (!this.model) || (!!this.passwordString && this.passwordString.length >= this.model.minLength);
    }

    public exceedsLengthRequirement(): boolean {
        return (!this.model) || (!!this.passwordString && this.passwordString.length > this.model.maxLength);
    }
}
